/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoleDTO
 */
export interface RoleDTO {
    /**
     * 
     * @type {string}
     * @memberof RoleDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RoleDTO
     */
    description?: string;
}

/**
 * Check if a given object implements the RoleDTO interface.
 */
export function instanceOfRoleDTO(value: object): value is RoleDTO {
    return true;
}

export function RoleDTOFromJSON(json: any): RoleDTO {
    return RoleDTOFromJSONTyped(json, false);
}

export function RoleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function RoleDTOToJSON(value?: RoleDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'description': value['description'],
    };
}

